export default function Contact() {
  return (
    <div>
     <hr className="h-3 text-center text-yellow-500"/>
     <div className="flex justify-center mt-10 pb-32">
     <div className="flex flex-wrap justify-center gap-32 text-white">
      <div>
          Just a Developer with near-sightedness 
      </div>
      <div>
          Delhi,India
      </div>
      <div>
        <p><a href="#">LinkedIn</a></p>
        <p><a href="https://github.com/ryuk-jayant">Github</a></p>
        <p><a href="https://discord.com/channels/j_wick0x00">Discord</a></p>
      </div>
      <div>
          @copymywork
      </div>
     </div>
     </div>
    </div>
  );
}
